import { Component, ChangeDetectionStrategy } from '@angular/core';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'app-unsaved-changes-dialog',
    imports: [
        MatDialogModule,
        MatButtonModule,
    ],
    templateUrl: './unsaved-changes-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './unsaved-changes-dialog.component.css'
})
export class UnsavedChangesDialogComponent {

}
